/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Sync_OptionsInputs */

const cs_settings_calendar_sync_options = /** @type {(inputs: Settings_Calendar_Sync_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co synchronizovat`)
};

const en_settings_calendar_sync_options = /** @type {(inputs: Settings_Calendar_Sync_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What to sync`)
};

/**
* | output |
* | --- |
* | "What to sync" |
*
* @param {Settings_Calendar_Sync_OptionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_sync_options = /** @type {((inputs?: Settings_Calendar_Sync_OptionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Sync_OptionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_sync_options(inputs)
	return cs_settings_calendar_sync_options(inputs)
});